import { t } from "@lingui/macro";
import { defaultSections } from "@reactive-resume/schema";
import { RichInput, Tooltip } from "@reactive-resume/ui";
import { cn } from "@reactive-resume/utils";

import { AiActions } from "@/client/components/ai-actions";
import { useResumeStore } from "@/client/stores/resume";

import { getSectionIcon } from "./shared/section-icon";
import { SectionOptions } from "./shared/section-options";
import { SectionItem} from "@reactive-resume/schema";
import { useEffect, useState} from "react";
type Props<T extends SectionItem> = {

  name?: any;
  limit?: any;
};

export const SummarySection = <T extends SectionItem>({name,limit}: Props<T>) => {
  const [limit_check,setLimit]:any  = useState()
  const setValue = useResumeStore((state) => state.setValue);
  const section = useResumeStore((state) =>  state.resume.data.sections.summary ?? defaultSections.summary);
  useEffect(()=>{
  if (section.content){
    if (section.content.length > limit){
      setLimit(true)
    }
    else{
      setLimit(false)
    }
  }
},[section.content])

  return (
    <section id="summary" className="grid gap-y-6">
      <header className="flex items-center justify-between">
        <div className="flex items-center gap-x-4">
          {getSectionIcon("summary")}
          <h2 className=" text-3xl font-bold">{name} <Tooltip content={t`Work Summary`}>
          
        
          <i className="fas fa-info-circle text-orange-500 i-75-cent"></i></Tooltip></h2>
        </div>

        <div className="flex items-center gap-x-2">
          <SectionOptions id="summary" />
        </div>
      </header>

      <main className={cn(!section.visible && "opacity-50")}>
        <RichInput
          content={section.content}
          onChange={(value) => setValue("sections.summary.content", value)}
          footer={(editor) => (
            <AiActions value={editor.getText()} onChange={editor.commands.setContent}  />
          )}
        />
      </main>
      {limit_check && (<label className="text-error">Summary must contain at most {limit} character(s)  </label>)}
      
    </section>
  );
};
